import { render, staticRenderFns } from "./ServiceIcon.vue?vue&type=template&id=f24c6d0a"
import script from "./ServiceIcon.vue?vue&type=script&lang=js"
export * from "./ServiceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports